<template>
	<div class="notif-icon" :class="{ 'notif-icon--disabled': disabled }" :title="title">
		<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve">
			<path d="M12,22C13.1,22 14,21.1 14,20L10,20C10,21.1 10.9,22 12,22ZM18,16L18,11C18,7.93 16.37,5.36 13.5,4.68L13.5,4C13.5,3.17 12.83,2.5 12,2.5C11.17,2.5 10.5,3.17 10.5,4L10.5,4.68C7.64,5.36 6,7.92 6,11L6,16L4,18L4,19L20,19L20,18L18,16ZM16,17L8,17L8,11C8,8.52 9.51,6.5 12,6.5C14.49,6.5 16,8.52 16,11L16,17Z"/>
			<g class="strike">
				<path d="M27.399,5.358L27.399,3.358L5.399,3.358L5.399,5.358L27.399,5.358Z" class="strike-negative"/>
				<path d="M27.414,3.358L27.414,1.358L5.414,1.358L5.414,3.358L27.414,3.358Z" class="strike-bg"/>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
  },
  computed: {
    title() {
      return this.disabled ? 'Désactiver les notificitions' : 'Activer les notifications'
    },
  },
}
</script>

<style lang="scss">
@import "../../../static/scss/variables";
.notif-icon {
	cursor: pointer;

	// Fill
	fill: #d0cecd;
	.strike-negative {
		fill: $primary;
	}
	.strike-bg {
		fill: #FFF;
	}

	.strike {
		transform: rotate(45deg) scaleX(0);
    	transform-origin: 5.4px 3.4px;
		transition: transform 0.2s;
	}
	&--disabled {
		.strike {
			transform: rotate(45deg) scaleX(1);
		}
	}
}
</style>
